import React from 'react';
import styled from 'styled-components';
import { isMobile } from 'react-device-detect';
import { ReactSVG } from 'react-svg';
import Config from '../../../config';

const AppAnnouncementNotification = () => {
  return (
    <Container>
      <IconWrapper>
        <Icon src={Config.ImageAssets.notifications.info} />
      </IconWrapper>
      <Title>{Config.TextStrings.announcementTitle}</Title>
      <Close>
        <Icon src={Config.ImageAssets.notifications.close} />
      </Close>
      <MessageWrapper>
        <Message>{Config.TextStrings.announcementMessage}</Message>
      </MessageWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${Config.Color.dark};
  background-color: ${Config.Color.yellow};
  height: 'auto';
  text-align: center;
  display: grid;
  padding: ${isMobile ? 0 : '16px'};
  margin: ${isMobile ? '8px 8px 0 8px' : '12px 12px 0 12px'};
  grid-template-columns: ${isMobile ? '60px auto 60px' : '80px auto 80px'};
  grid-template-rows: 2;
  justify-items: center;
  border-radius: 5px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);
`;

const Title = styled.div`
  align-self: center;
  justify-self: left;
  font-weight: 600;
  padding: 12px 0;
  grid-row-start: 1;
  grid-column-start: 2;
`;

const IconWrapper = styled.div`
  align-self: center;
  grid-row-start: 1;
  grid-column-start: 1;
  padding: 6px;
`;

const Icon = styled(ReactSVG)`
  svg path {
    fill: currentColor;
  }
`;

const MessageWrapper = styled.div`
  align-self: center;
  justify-self: left;
  padding-bottom: 12px;
  grid-row-start: 2;
  grid-column-start: 2;
`;

const Message = styled.div`
  text-align: left;
  font-size: ${isMobile ? '12px' : '16px'};
  font-weight: 400;
`;

const Close = styled.div`
  align-self: center;
  grid-row-start: 1;
  grid-column-start: 3;
  padding: 6px;
`;

export default AppAnnouncementNotification;
